import React, {useEffect, useState, useRef} from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";
import Lottie from 'react-lottie';
import WorldMap from '../../../assets/lotties/world-map.json'
import WorldMapMobile from '../../../assets/lotties/world-map-mobile.json'
import BoneRoasters from '../../../assets/lotties/bone-roaster.json'
import BoneRoastersMobile from '../../../assets/lotties/bone-roaster-mobile.json'
import FourLocations from '../../../assets/lotties/four-locations.json'

const MapLottie = ({title, richContent, mapStyle, theme}) => {
  const [inView, setInView] = useState(false);
  const mapRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null, rootMargin: '0px', threshold: 0.5
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      });
    }, options);

    if (mapRef.current) {
      observer.observe(mapRef.current);
    }

    return () => {
      if (mapRef.current) {
        observer.unobserve(mapRef.current);
      }
    };
  }, []);

  const animations = {
    'four_locations_map': {desktop: FourLocations},
    'world_map': {desktop: WorldMap, mobile: WorldMapMobile},
    'bone_roasters': {desktop: BoneRoasters, mobile: BoneRoastersMobile}
  };

  const {desktop: desktopAnimation, mobile: mobileAnimation} = animations[mapStyle] || {};

  const desktopOptions = {
    loop: true,
    autoplay: inView,
    animationData: desktopAnimation,
    rendererSettings: {preserveAspectRatio: "xMidYMid slice"}
  };

  const mobileOptions = {
    ...desktopOptions, animationData: mobileAnimation || desktopAnimation
  };

  return (
    <section ref={mapRef} className={`map-lottie ${theme || ''}`}>
      <div className="map-lottie__inner" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
        {title && <h2>{parse(title)}</h2>}
        {richContent && <div className="map-lottie__content">{<StructuredText data={richContent}/>}</div>}
      </div>

      <div className="map-lottie__map">
        <div className="map-lottie__map-desktop">
          <Lottie options={desktopOptions} height={`100%`} width={`100%`}/>
        </div>
        <div className="map-lottie__map-mobile">
          <Lottie options={mobileOptions} height={`100%`} width={`100%`}/>
        </div>
      </div>
    </section>
  )
}

export default MapLottie

export const query = graphql`
fragment MapLottieProps on DatoCmsMapLottie {
  ... on DatoCmsMapLottie {
    id
    title
    mapStyle
    richContent {
      value
    }
  }
}
`;